import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { AppCommonsModule } from "src/app/commons/app-commons.module";
import { KYMW1602Component } from "./kymw1602.component";
import { FormsModule } from "@angular/forms";
import { PlessSharedModule } from "src/app/shared/pless-shared.module";

/**
 * 画像拡大画面
 * 
 * @export KYMW1602Module
 */
@NgModule({
    imports: [
        CommonModule,
        AppCommonsModule,
        FormsModule,
        PlessSharedModule,
    ],
    declarations: [
        KYMW1602Component,
    ],
    providers: []
})

export class KYMW1602Module {}